<template>
  <section
    id="join-profit"
    :class="[
      'section-join-profit section-content c-fff',
      { 'fade-in': isEnteringSectionJoinProfit },
    ]"
  >
    <div class="section-join-profit-content">
      <div class="title-wrapper">
        <h2 class="fz-40 fz-mbl-32 fz-mbp-26 fw-700 lh-11 ta-center">
          Quick, Easy and Transparent
        </h2>
        <h4 class="sub-title fz-18 fw-600 lh-11 ta-center">
          Cooperate with GANGA7 and receive up to 50% of the company's net
          earnings.
        </h4>
      </div>

      <div
        :class="[
          'image-man-wrapper',
          { 'man-fade-in': isEnteringSectionJoinProfit },
        ]"
      >
        <img
          src="~@/assets/images/section-join-profit/join-profit-man.png"
          class="image-man"
        />
      </div>

      <div class="profits">
        <div
          v-for="(profitContent, profitItem) in profitData"
          :class="[
            `profit-item profit-item--${profitItem}`,
            { 'fade-in': isEnteringSectionJoinProfit },
          ]"
          :key="profitItem"
        >
          <img :src="profitContent.image" alt="" class="profit-item__image" />
          <p class="profit-item__text fz-18 fz-mbl-16 fz-mbp-14 fw-600">
            {{ profitContent.text }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionJoinProfit: {
      type: Boolean,
    },
  },

  data() {
    return {
      profitData: {
        income: {
          image: require("@/assets/images/section-join-profit/icon-income.png"),
          text: "Receive an income from 20% to 50% of the profit share.",
        },
        commission: {
          image: require("@/assets/images/section-join-profit/icon-commission.png"),
          text: "Earn 5% of commission of the total amount.",
        },
      },
    };
  },
};
</script>

<style lang="scss">
.section-join-profit {
  @include mq(dsk) {
    height: 700px;
  }

  display: flex;
  justify-content: center;

  min-height: 520px;
  padding: 80px 5% 40px;

  transition: all 0.5s 0.3s;

  opacity: 0;

  &.fade-in {
    opacity: 1;
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    width: 720px;
  }

  .title-wrapper {
    z-index: 1;

    .sub-title {
      margin-top: 20px;
    }
  }

  .image-man-wrapper {
    @include mq(dsk) {
      padding-top: 45px;
    }

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    padding-top: 120px;

    transform: rotateY(-70deg);
    transition: all 1.2s 0.7s;

    opacity: 0;
    overflow: hidden;

    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background: linear-gradient(
        0deg,
        rgba(4, 12, 26, 1) 0%,
        rgba(0, 0, 0, 0) 30%
      );

      content: "";
    }

    &.man-fade-in {
      transform: rotateY(0deg);

      opacity: 1;
    }

    .image-man {
      flex-grow: 0;
      flex-shrink: 0;
      height: 100%;
    }
  }

  .profits {
    display: flex;
    justify-content: space-between;

    width: 100%;

    .profit-item {
      display: flex;

      opacity: 0;

      &.fade-in {
        opacity: 1;
      }

      &--income {
        transition: all 0.7s 1.4s;
      }

      &--commission {
        padding-left: 10px;

        transition: all 0.7s 1.8s;
      }

      &__image {
        @include mq(dsk) {
          height: 48px;
          margin-right: 26px;
        }

        height: 30px;
        margin-right: 14px;
      }

      &__text {
        max-width: 224px;
      }
    }
  }
}
</style>
